<div class="feedback-dialog">
  <h2 class="feedback-dialog__title">{{ 'feedbackDialog.title' | translate }}</h2>

  <app-button
    class="feedback-dialog__close"
    [skin]="ButtonSkin.Secondary"
    [size]="ButtonSize.Small"
    (click)="dialogRef.close()"
  >
    <app-icon name="close" [size]="IconSize.Medium"></app-icon>
  </app-button>

  <div *ngIf="!selectedCategory">
    <p
      class="feedback-dialog__intro"
      [innerHTML]="'feedbackDialog.introHtml' | translate:{ email: 'support@ecofeast.app' }">
    </p>
    <div
      class="feedback-dialog__option"
      *ngFor="let option of options"
      (click)="select(option)"
    >
      <app-icon [name]="option.icon" [size]="IconSize.Large"></app-icon>
      {{ ('enums.feedbackCategoryLabel.' + option.label) | translate }}
    </div>
  </div>

  <form
    *ngIf="selectedCategory"
    (ngSubmit)="submit()"
    class="feedback-dialog__form"
    #formRef="ngForm"
  >
    <h3>
      <app-icon [name]="selected.icon" [size]="IconSize.Medium"></app-icon>
      {{ ('enums.feedbackCategoryLabel.' + selected.label) | translate }}
    </h3>

    <mat-form-field appearance="fill">
      <mat-label>{{ 'feedbackDialog.titleLabel' | translate }}</mat-label>
      <input
        matInput
        [(ngModel)]="form.title"
        name="title"
        required
        maxlength="100"
        #titleRef="ngModel"
      />
      <mat-hint align="end">{{ form.title.length }}/100</mat-hint>
      <mat-error *ngIf="titleRef.invalid && titleRef.touched">
        {{ 'feedbackDialog.titleError' | translate }}
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="fill">
      <mat-label>{{ 'feedbackDialog.detailsLabel' | translate }}</mat-label>
      <textarea
        matInput
        [(ngModel)]="form.details"
        name="details"
        required
        maxlength="2000"
        rows="5"
        #detailsRef="ngModel"
      ></textarea>
      <mat-hint align="end">{{ form.details.length }}/2000</mat-hint>
      <mat-error *ngIf="detailsRef.invalid && detailsRef.touched">
        {{ 'feedbackDialog.detailsError' | translate }}
      </mat-error>
    </mat-form-field>

    <div class="feedback-dialog__actions">
      <app-button
        [skin]="ButtonSkin.Secondary"
        [size]="ButtonSize.Medium"
        [type]="ButtonType.Button"
        (click)="reset()"
      >
        {{ 'common.back' | translate }}
      </app-button>

      <app-button
        [skin]="ButtonSkin.Primary"
        [size]="ButtonSize.Medium"
        [type]="ButtonType.Submit"
        [isDisabled]="formRef.invalid"
      >
        {{ 'common.submit' | translate }}
      </app-button>
    </div>
  </form>
</div>
